import React, { useState, useEffect } from 'react';
import { fetchDashboardCounts } from '../apiCalls';
import PublishingStepper from './PublishingStepper';
export default function Dashboard() {
    const [count, setCounts] = useState({ book: 0, author: 0, category: 0, testimonial: 0 });
    const getCounts = async () => {
        console.log("1. getCounts function started"); // LOG 1
        try {
            const res = await fetchDashboardCounts();
            console.log("2. API response received:", res); // LOG 2

            if (res) {
                const data = res.data ? res.data : res;
                console.log("3. Data to be set in state:", data); // LOG 3

                setCounts({
                    book: data.total_books || 0,
                    author: data.total_authors || 0,
                    category: data.total_categories || 0,
                    testimonial: data.total_testimonials || 0
                });
            }
        } catch (error) {
            console.error("API Error in Dashboard:", error);
        }
    };

    useEffect(() => {
        getCounts();
    }, []);
    return (
        <>
            <div className='pt-5'>
                <div className="row">
                    <div className="col-3">
                        <div className="bg-dark p-10 text-white text-center counter">
                            <i className="bi bi-journals fs-3 mb-1 font-16"></i>
                            <h5 className="mb-0 mt-1">{count.book}</h5>
                            <small className="font-light">Total Books</small>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="bg-dark p-10 text-white text-center counter">
                            <i className="bi bi-people fs-3 mb-1 font-16"></i>
                            <h5 className="mb-0 mt-1">{count.author}</h5>
                            <small className="font-light">Total Authors</small>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="bg-dark p-10 text-white text-center counter">
                            <i className="bi bi-bookmarks-fill fs-3 mb-1 font-16"></i>
                            <h5 className="mb-0 mt-1">{count.category}</h5>
                            <small className="font-light">Book Categories</small>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="bg-dark p-10 text-white text-center counter">
                            <i className="bi bi-balloon-heart fs-3 mb-1 font-16"></i>
                            <h5 className="mb-0 mt-1">{count.testimonial}</h5>
                            <small className="font-light">Testimonials</small>
                        </div>
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className=''>
                        <PublishingStepper />
                    </div>
                </div>
            </div>
        </>
    )
}
